import { getQueryParamValue } from "../App/utils";

export function getUrlSecretKeys() {
    const addSecretsParam = getQueryParamValue('add_secrets');
    if (!addSecretsParam) return [];

    // Parse the comma-separated keys
    const keys = addSecretsParam.split(',').map(item => {
        const trimmed = item.trim();
        // If there's a pipe separator, take only the key part
        const parts = trimmed.split('|');
        return parts[0].trim();
    }).filter(Boolean);
    return keys;
}

export function getUrlSecretsWithLabels() {
    const addSecretsParam = getQueryParamValue('add_secrets');
    if (!addSecretsParam) return [];

    // Parse the comma-separated items with optional labels and input types
    // Format: key|label|inputType where label and inputType are optional
    const items = addSecretsParam.split(',').map(item => {
        const trimmed = item.trim();
        const parts = trimmed.split('|');
        return {
            key: parts[0].trim(),
            label: parts[1] ? parts[1].trim() : parts[0].trim(), // Use label if provided, otherwise use key
            inputType: parts[2] ? parts[2].trim() : 'password' // Default to password if not specified
        };
    }).filter(item => item.key);

    return items;
}